// ---------------------------------------------------------------
// privacyService.js — Constancia de que cada persona ha leído el
// aviso de privacidad, y con qué versión del texto.
// Colección `privacyAck/{uid}` = { version, acceptedAt, username }.
// ---------------------------------------------------------------
import { doc, onSnapshot, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "../firebase";
import { sharedSubscribe } from "../utils/sharedSnapshot";
import { PRIVACY_VERSION } from "../utils/privacyNotice";

export function subscribePrivacyAck(uid, onData, onError) {
  if (!uid) {
    onData(null);
    return () => {};
  }
  return sharedSubscribe(
    `privacyAck:${uid}`,
    (cb, err) =>
      onSnapshot(
        doc(db, "privacyAck", uid),
        (snap) => cb(snap.exists() ? snap.data() : null),
        err
      ),
    onData,
    onError
  );
}

export function ackPrivacy(uid, username) {
  return setDoc(doc(db, "privacyAck", uid), {
    version: PRIVACY_VERSION,
    username: username || "",
    acceptedAt: serverTimestamp(),
  });
}
